export class ActivityInformationDTO {
  activityNumber: number;
  activityTariffDescription: string;
  date: string;
  quantity: string;
  amount: string;
  diagnosis: string;
  observations: string
}
